import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'

import { Translation } from '@/app/translations/Translation'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { numberFormat } from '@/util/formatters/numbers'

import './progress-buttons.scss'

const ProgressButtons: FC<{
  orderSummary: { products: number; cost: number; currency: string | null } | undefined
  isAccessoriesAvailable?: boolean
  advanceWizard: (() => void) | undefined
  regressWizard: (() => void) | undefined
}> = ({ orderSummary, isAccessoriesAvailable, advanceWizard, regressWizard }) => {
  if (!orderSummary) return null

  const { products, cost, currency } = orderSummary

  return (
    <div className="progress-buttons">
      <Button Icon={<ChevronLeftIcon />} onClick={regressWizard}>
        <Translation id="Previous Step" />
      </Button>

      <div className="order-summary">
        <div className="order-summary__products">
          {numberFormat(products)}{' '}
          {products !== 1 ? <Translation id="products" /> : <Translation id="product" />}
        </div>
        <div className="order-summary__cost">
          <FormattedNumberWithCurrency amount={cost} currency={currency} />
        </div>
      </div>

      <Button
        Icon={<ChevronRightIcon />}
        isIconRight={true}
        // There might appear accessories independent of the selected products
        disabled={products <= 0 && !isAccessoriesAvailable}
        onClick={advanceWizard}
      >
        <Translation id="Next Step" />
      </Button>
    </div>
  )
}

export default ProgressButtons
